import * as APP_CONFIG from "../constants/config";

const apiBase = APP_CONFIG.malfunctionapi;

function malfunctionsHasErrored(bool) {
    return {
        type: 'MALFUNCTIONS_HAS_ERRORED',
        hasErrored: bool,
        isLoading: false,
    };
}

function malfunctionsIsLoading(bool) {
    return {
        type: 'MALFUNCTIONS_IS_LOADING',
        isLoading: bool
    };
}

function malfunctionsFetchListSuccess(malfunctions) {
    return {
        type: 'MALFUNCTIONS_FETCH_LIST_SUCCESS',
        isLoading: false,
        malfunctions
    };
}

/*export const setToken = (token = '') => ({
    type: 'SET_TOKEN',
    token
});*/

export function malfunctionsFetchList() {

    return async (dispatch, getState) => {

        dispatch(malfunctionsIsLoading(true));

        try{
            const api = apiBase + 'malfunctions';
            const request  = await fetch(api);
            const response = await request.json();
            dispatch(malfunctionsFetchListSuccess(response.results));
        }
        catch(err){
            dispatch(malfunctionsHasErrored(true));
        }
    };
}

export function addMalfunction(_malfunction) {

    return async (dispatch, getState) => {

        try{
            const api = apiBase + 'malfunctions/add';

            const response = await fetch(api, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-type': 'application/json'
                },
                body: JSON.stringify({malfunction: _malfunction})
            });

            const responseJson = await response.json();

            return responseJson;
        }
        catch (e) {
            dispatch(malfunctionsHasErrored(true));
        }

    }
}

export function updateMalfunction(_malfunction) {

    return async (dispatch) => {

        try{
            //console.log(`actions updateMalfunction`);

            const api = apiBase + 'malfunctions/update';

            const response = await fetch(api, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-type': 'application/json'
                },
                body: JSON.stringify({malfunction: _malfunction})
            });
            if (!response.error) {
                const responseJson = await response.json();

                //console.log(`geen error updateMalfunction`);

                return responseJson.result;

            }
            else {
                console.log(`error updateMalfunction`);
            }

        }
        catch (e) {
            dispatch(malfunctionsHasErrored(true));
        }
    }
}

export function addAction(_action) {

    return async (dispatch, getState) => {

        try{
            const api = apiBase + 'actions/add';

            const response = await fetch(api, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-type': 'application/json'
                },
                body: JSON.stringify({action: _action})
            });
            const responseJson = await response.json();

            return responseJson;

        }
        catch (e) {
            console.log(`error add action: ${e}`);
            dispatch(malfunctionsHasErrored(true));
        }

    }
}

export function updateAction(_action) {

    return async (dispatch, getState) => {

        try{
            const api = apiBase + 'actions/update';

            await fetch(api, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-type': 'application/json'
                },
                body: JSON.stringify({action: _action})
            });
        }
        catch (e) {
            console.log(`error update action: ${e}`);
            dispatch(malfunctionsHasErrored(true));
        }

    }
}

export function addFoto(_foto) {

    return async (dispatch, getState) => {

        try{
            const api = apiBase + 'fotos/add';

            await fetch(api, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-type': 'application/json'
                },
                body: JSON.stringify({foto: _foto})
            });
        }
        catch (e) {
            console.log(`error add foto: ${e}`);
            dispatch(malfunctionsHasErrored(true));
        }

    }
}

export function deleteFoto(_foto) {

    return async (dispatch, getState) => {

        try{
            const api = apiBase + 'fotos/delete';

            await fetch(api, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-type': 'application/json'
                },
                body: JSON.stringify({foto: _foto})
            });
        }
        catch (e) {
            console.log(`error delete foto: ${e}`);
            dispatch(malfunctionsHasErrored(true));
        }

    }
}


// WEBPACK FOOTER //
// ./src/actions/malfunctions.js